class Instagram2 extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('id');
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(`#${this.sectionId} .Index_instagram_slider`, {
      loop: !0,
      grabCursor: !1,
      spaceBetween: 16,
      slidesPerView: 5,
      watchSlidesProgress: !0,
      scrollbar: {
        el: ".swiper-scrollbar"
      },
      autoplay: {
        delay: 5e3
      },
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      mousewheel: {
        forceToAxis: !0
      },
      centeredSlides: !0,
      breakpoints: {
        0: {
          slidesPerView: "auto",
          centeredSlides: !0
        },
        769: {
          slidesPerView: "auto"
        },
        992: {
          slidesPerView: "auto"
        },
        1200: {
          slidesPerView: "auto"
        },
        1360: {
          slidesPerView: "auto"
        },
        1441: {
          slidesPerView: 5,
          centeredSlides: !1,
          freeMode: 1
        }
      }
    })
  }
}
if (!window.customElements.get("m-ins")) {
  window.customElements.define("m-ins", Instagram2);
}